import Reflux from 'reflux';

const MetaDataActions = Reflux.createActions([
   "setTitle",
   "setDescription"
]);

export {MetaDataActions};


// WEBPACK FOOTER //
// ./src/app/page-content/meta-data-tags/actions.js